<div class="modal-header border-0">
  <button type="button" class="btn btn-close" aria-label="Close" (click)="dismissSwapSupervisorModal()"></button>
</div>
<div class="modal-body py-0 pb-2 px-sm-5">
  <form [formGroup]="form"  class="d-flex flex-column p-0 content">
    <div class="d-flex flex-column search-results">
      <div class="title large-bold-text">Swap Supervisor</div>
      <div class="sub-title small-gray-text">This student currently has: <span class="small-bold-text">{{currentSupervisor?.firstName}} {{currentSupervisor?.lastName}}</span> as their supervisor. Select a supervisor below to swap the student's supervisor.</div>
      <div class="input-wrapper f-row align-items-center">
        <app-icon icon="search" class="large-icon search-icon"></app-icon>
        <input [ngClass]="setStyle('supSearch', form)" class="custom-input" matInput formControlName="searchTerm"
               aria-label="Supervisor Search" placeholder="Search supervisors in this opportunity">
      </div>
      @if (filteredSupervisors.length > 0) {
        <div class="d-flex flex-column mt-3 bg-light w-100">
          @for (supervisor of filteredSupervisors; track supervisor.id) {
            <app-supervisor-info-card [supervisor]="supervisor"
                                      [viewType]="'sup-list-swap'"
                                      [isSelected]="isSelected(supervisor)"
                                      (click)="selectSupervisor(supervisor)"
                                      class="supervisor-card"
                                      #SupervisorInfoCard>
            </app-supervisor-info-card>
          }
        </div>
      }
    </div>
  </form>
</div>
<div class="modal-footer px-sm-5 border-0">
  <div class="d-flex flex-row gap-3 w-100 actions">
    <button class="custom-button-large-secondary w-100" (click)="dismissSwapSupervisorModal()">Cancel</button>
    <button class="custom-button-large-primary-dark-blue w-100" type="button" [disabled]="!canSwapSupervisor()" (click)="save()">Save</button>
  </div>
</div>
